export default __webpack_public_path__ + "static/media/privacy-policy.8485f384.jpg";